import { Flex } from '@mantine/core';
import { FC, memo } from 'react';
import { Button } from 'src/components/Button';

type Props = {
  onDeleteClick: () => void;
};

export const ThemeFooter: FC<Props> = memo(({ onDeleteClick }) => {
  return (
    <Flex justify="flex-end" mt="xl">
      <Button size="md" round variant="danger" onClick={onDeleteClick}>
        DELETE
      </Button>
    </Flex>
  );
});
ThemeFooter.displayName = 'ThemeFooter';
